module.exports = __webpack_public_path__ + "static/bridePic.b0de3f2e.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/bridePic.png
// module id = 457
// module chunks = 168707334958949